<template>
  <div class="notification-rule-page">
    <Breadcrumb :breadcrumbList="breadcrumbList" />
    <div class="content-header px-0">
      <h1 class="title-I">Adicionar Regra</h1>
    </div>
    <div class="col-12 col-sm-12 p-0 col-md-12">
      <form @submit="addNotificationRule" novalidate="true">
        <div class="card direct-chat direct-chat-primary">
          <div class="card-body">
            <div class="pl-4 pt-4 pr-4 bg-white rounded">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label>Regra <span class="required">*</span></label>
                    <input
                      id="nameNotification"
                      v-model="notificationRule.name"
                      required
                      type="text"
                      maxlength="128"
                      class="form-control"
                      placeholder="Regra"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <div class="row">
                    <div class="form-group col-12 mb-2">
                      <label>Usuários <span class="required">*</span></label>
                      <input
                        id="filter-bar"
                        v-model="filterUsers"
                        type="search"
                        class="form-control col-12 w-100"
                        placeholder="Buscar"
                      />
                    </div>
                  </div>
                  <div class="row pr-2 pl-2">
                    <button
                      id="select-all-btn"
                      type="button"
                      class="btn btn-light table-header-button col-12"
                      @click="onSelectAll"
                    >
                      <i class="fas fa-chevron-right"></i>
                      <i class="fas fa-chevron-right"></i>
                    </button>
                    <b-table
                      id="userTable"
                      class="custom-scroll"
                      thead-class="user-table-header"
                      empty-text="Não há usuários cadastrados"
                      hover
                      borderless
                      no-sort-reset
                      show-empty
                      :busy="load"
                      :fields="fieldsSelectUser"
                      :items="unselectedUsers"
                      :filter="filterUsers"
                      @row-clicked="onSelectUser"
                    >
                      <template v-slot:table-busy>
                        <div class="text-center my-2">
                          <strong>
                            <i class="fas fa-sync-alt fa-spin"></i>
                          </strong>
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>
                <div class="col-6">
                  <div class="row">
                    <div class="form-group col-12 mb-2">
                      <label>Usuários que vão receber alertas</label>
                      <input
                        id="filter-bar-sel-users"
                        v-model="filterSelectedUsers"
                        type="search"
                        class="form-control col-12 w-100"
                        placeholder="Buscar"
                      />
                    </div>
                  </div>

                  <div class="row pr-2 pl-2">
                    <button
                      id="deselect-all-btn"
                      type="button"
                      class="btn btn-light table-header-button col-12"
                      @click="onDeselectAll"
                    >
                      <i class="fas fa-chevron-left"></i>
                      <i class="fas fa-chevron-left"></i>
                    </button>
                    <b-table
                      class="custom-scroll"
                      thead-class="user-table-header"
                      empty-text="Não há usuários selecionados"
                      hover
                      borderless
                      no-sort-reset
                      show-empty
                      :busy="load"
                      :fields="fieldsDeselectUser"
                      :items="selectedUsers"
                      :filter="filterSelectedUsers"
                      @row-clicked="onDeselectUser"
                    >
                      <template v-slot:table-busy>
                        <div class="text-center my-2">
                          <strong>
                            <i class="fas fa-sync-alt fa-spin"></i>
                          </strong>
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <div class="form-group">
                    <label
                      >Selecione as ações <span class="required">*</span></label
                    >
                    <b-form-checkbox-group
                      id="checkBox1"
                      v-model="selectedActions"
                      stacked
                      plain
                      :options="actionOptions"
                    />
                  </div>
                </div>
              </div>

              <!-- Início classe-->
              <div class="row">
                <TwInput v-show="classes.length > 1" col_lg="3" label="Classe">
                  <!-- <label
                    >Selecione os alertas para notificações
                    <span class="required">*</span></label
                  > -->
                  <select id="formclasses"  class="form-control"  v-model="selectedClasses">
                    <option value="null" disabled selected>
                      Selecione a classe
                    </option>

                    <option
                      v-for="classe in classes"
                      :value="classe"
                      :key="classe.name"
                      :id="classe.name"
                    >
                      {{ classe.name }}
                    </option>
                  </select>
                </TwInput>
              </div>
              <!-- AQUI -->
              <label>Alerta<span class="required"> *</span></label> 
              <div class="row form-group limited-height-200 bordered-row">
                <b-form-group class="col-12 checkbox-group bordered-row">
                  <b-form-checkbox-group
                    v-model="selectedAlerts"
                    style="column-count: 2"
                    stacked
                    plain
                    :options="alerts"
                  ></b-form-checkbox-group>
                </b-form-group>
              </div>
              <!-- <div v-if="passkey" class="row">
                <div class="col-12">
                  <label
                    >Selecione os alertas para notificações
                    <span class="required">*</span></label
                  >
                  <div class="row form-group limited-height-200 bordered-row">
                    <b-form-group class="col-12 checkbox-group bordered-row">
                      <b-form-checkbox-group
                        id="checkBox2"
                        v-model="selectedAlerts"
                        style="column-count: 2"
                        stacked
                        plain
                        :options="alerts"
                      />
                    </b-form-group>
                  </div>
                </div>
              </div> -->
              <div class="row">
                <div class="col-4 mb-0">
                  <div class="form-group mb-0">
                    <label>Status <span class="required"> *</span></label>
                    <b-form-group>
                      <b-form-radio-group
                        v-model="selectedStatus"
                        :options="statusOptions"
                        plain
                        name="status"
                        id="status"
                      />
                    </b-form-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <button id="saveNotification" class="btn btn-primary">
              Salvar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../../components/Breadcrumb.vue";
import "./styles.scss";
import TwInput from "@/components/TwInput";

export default {
  name: "AddNotificationRule",
  data: function () {
    return {
      key: "",
      passShow: false,
      passkey: false,
      classe: null,
      breadcrumbList: [],
      filterUsers: null,
      selectedClasses: null,
      filterSelectedUsers: null,
      notificationRule: {
        name: "",
        status: "",
        customer_id: null,
        actions: [],
        alerts: [],
        users: [],
      },
      selectedUsers: [],
      fieldsSelectUser: [{ key: "name", sortable: true, label: "Nome" }],
      fieldsDeselectUser: [{ key: "name", sortable: true, label: "Nome" }],
      selectedActions: [],
      actionOptions: [
        { text: "Email", value: "EMAIL" },
        { text: "SMS", value: "SMS" },
        { text: "Push", value: "PUSH" },
        { text: "Log", value: "LOG" },
        { text: "Voice", value: "VOICE" },
        { text: "WhatsApp", value: "WHATSAPP" },
      ],
      selectedAlerts: [],
      selectedStatus: "ATIVO",
      statusOptions: [
        { text: "Ativo", value: "ATIVO" },
        { text: "Inativo", value: "INATIVO" },
      ],
    };
  },
  mounted() {
    if (this.$route.params.customerId) {
      this.$store.dispatch("customer/getCustomer", {
        customerId: this.$route.params.customerId,
      });

      this.$store.dispatch("notificationRule/getUsers", {
        customerId: this.$route.params.customerId,
      });
    } else {
      window.frontMsg(
        "FRNT_MISSING_WARNING",
        { frontelement: "do Cliente" }
      );
      this.$router.push("/");
    }

    this.$store.dispatch("alert/get");
    this.$store.dispatch("alert/getAlertsClasses");
    // this.$store.dispatch("alert/ getCustomerAlerts");
    this.updateList();
  },
  watch: {
    classes() {
      if (this.classes.length < 0) {
        this.selectedClasses = this.classe[2];
      }
      // this.classe = null;
    },
    selectedClasses() {
      this.$store.dispatch("alert/getAlertsClasses", this.selectedClasses.name);
      // this.classe = null;
    },
    // selectedAlerts() {
    //   this.$store.dispatch("alert/getCustomerAlerts", this.selectedAlerts.name);
    //   this.alerts = null;
    // },
    customer() {
      if (this.customer) {
        this.updateList();

        this.$store.dispatch("notificationRule/getUsers", {
          customerId: this.customer.id,
        });
      }
    },
  },
  methods: {
    updateList() {
      this.breadcrumbList = this.$route.meta.breadcrumb;
      if (this.customer) {
        this.breadcrumbList[1].label = `Editar cliente ${this.customer.company_name}`;
      }
    },
    cla() {
      this.claa = !this.claa;
    },
    showPass() {
      event.preventDefault();
      this.passShow = !this.passShow;
    },
    showkey() {
      this.passkey = !this.passkey;
    },
    onSelectUser(item) {
      this.selectedUsers.push(item);
    },
    onDeselectUser(item) {
      this.selectedUsers.splice(this.selectedUsers.indexOf(item), 1);
    },
    onSelectAll() {
      this.selectedUsers = [...this.users];
    },
    onDeselectAll() {
      this.selectedUsers = [];
    },
    isNotificationRuleValid(notificationRule) {
      if (!notificationRule.name || notificationRule.name.trim() === "") {
        window.frontMsg(
          "FRNT_EMPTY_WARNING",
          { field: "Nome da Regra" }
        );
        return false;
      }
      if (!notificationRule.users.length) {
        window.frontMsg(
          "FRNT_EMPTY_WARNING",
          { field: "Usuário" }
        );
        return false;
      }
      if (!notificationRule.actions.length) {
        window.frontMsg(
          "FRNT_EMPTY_WARNING",
          { field: "Ação" }
        );
        return false;
      }
      if (!this.selectedClasses) {
        window.frontMsg(
          "FRNT_EMPTY_WARNING",
          { field: "Classe" }
        );
        return false;
      }
      if (!notificationRule.alerts.length) {
        window.frontMsg(
          "FRNT_EMPTY_WARNING",
          { field: "Alerta" }
        );
        return false;
      }
      if (!notificationRule.status || notificationRule.status.trim() === "") {
        window.frontMsg(
          "FRNT_EMPTY_WARNING",
          { field: "Status" }
        );
        return false;
      }
      if (!this.customer || isNaN(this.customer.id)) {
        window.frontMsg(
          "FRNT_EMPTY_WARNING",
          { field: "Cliente" }
        );
        return false;
      }
      return true;
    },
    addNotificationRule() {
      event.preventDefault();
      this.notificationRule.users = this.selectedUsers.map(
        (user) => user.email
      );
      this.notificationRule.actions = this.selectedActions;
      this.notificationRule.alerts = this.selectedAlerts;
      this.notificationRule.status = this.selectedStatus;
      this.notificationRule.customer_id = this.customer.id;
      // this.notificationRule.classe = this.classe;

      if (!this.isNotificationRuleValid(this.notificationRule)) {
        return;
      }

      this.$store.dispatch("notificationRule/saveNotificationRule", {
        notificationRule: this.notificationRule,
      });
    },
  },
  computed: {
    load() {
      return this.$store.getters["load"];
    },
    customer() {
      return this.$store.getters["customer/customer"];
    },
    users() {
      return this.$store.getters["notificationRule/users"].map((user) => ({
        name: user.name,
        email: user.email,
      }));
    },
    unselectedUsers() {
      if (this.users)
        return this.users.filter((user) => !this.selectedUsers.includes(user));

      return [];
    },
    alerts() {
      return this.$store.getters["alert/alerts"].map((alert) => ({
        text: alert.msg,
        value: alert.code,
      }));
    },
    classes() {
      let classes = this.$store.getters["alert/classes"];
      classes = classes.filter((classes) => {
        return classes.name;
      });
      return classes;
    },
  },
  components: {
    Breadcrumb,
    TwInput,
  },
};
</script>
